import { render, staticRenderFns } from "./SortInput.vue?vue&type=template&id=f53f4cd2"
import script from "./SortInput.vue?vue&type=script&lang=js"
export * from "./SortInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports